import { breadcrumbSession } from '../../../helpers/misc/session'
import { assertIsNotNullish } from '../../..//helpers/misc/assertionFunctions'

declare global {
  interface Window {
      breadcrumbInfo: string
  }
}

class BreadcrumbsHelper {
  private route: string = ''
  private isMounted: boolean = false
  private setRoute: (a: string) => void
  private setSupplier: (a: string) => void
  private setPropertyName: (a: string) => void
  private setPath: (a: boolean) => void
  private registeredEvents: string[]
  private setUserInfo: (a: {}) => void

  constructor(
    route: string,
    isMounted: boolean,
    setRoute: (a: string) => void,
    setSupplier: (a: string) => void,
    setPropertyName: (a: string) => void,
    setPath: (a: boolean) => void,
    setUserInfo: (a: {}) => void
  ) {
    this.route = route
    this.isMounted = isMounted
    this.setRoute = setRoute
    this.setSupplier = setSupplier
    this.setPropertyName = setPropertyName
    this.setPath = setPath
    this.registeredEvents = ['click','keydown']
    this.setUserInfo = setUserInfo
  }

  public async setSession(): Promise<void> {
    try {
      // @ts-expect-error
      const response: {
        session: {
          supplier: string,
          propertyName: string
        },
        path: boolean,
        userInfo: {
          view: boolean,
          value: string
        }
      } = await breadcrumbSession()
      this.setSupplier(response?.session?.supplier)
      this.setPropertyName(response?.session?.propertyName)
      this.setPath(response?.path)
      this.setRoute(window.breadcrumbInfo)
      this.setUserInfo(response?.userInfo)
    } catch (error) {
      throw Error(`${error}`)
    }
  }

  public addEventListenersHanlder(): void {
    this.registeredEvents.forEach((e) => {
      window.addEventListener(e, async () => {
        assertIsNotNullish(window.breadcrumbInfo)
        if (this.route === '' && this.isMounted) {
          // using a timer as we're waiting a fetch response
          setTimeout(async () => {
            const response: { session: { propertyName: string }
          } = await breadcrumbSession()
          this.setPropertyName(response?.session?.propertyName)
          }, 600)
          return this.setRoute(window.breadcrumbInfo)
        }
        if (window.breadcrumbInfo !== this.route && this.isMounted) {
          return this.setRoute(window.breadcrumbInfo)
        }
      });
    });
  }
  
  public removeEventListenerHandler(): void {
    this.registeredEvents.forEach((e) => {
      window.removeEventListener(e, () => {});
    });
  }
}



export default BreadcrumbsHelper

